var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88934 17.7652C5.98714 17.9119 6.15182 18 6.32812 18C6.50443 18 6.66911 17.9119 6.76691 17.7652C8.01492 15.8932 9.85314 13.5813 11.1341 11.23C12.1583 9.34998 12.6562 7.74654 12.6562 6.32812C12.6562 2.8388 9.81745 0 6.32812 0C2.8388 0 0 2.8388 0 6.32812C0 7.74654 0.497918 9.34998 1.52216 11.23C2.80216 13.5795 4.64389 15.8971 5.88934 17.7652ZM6.32812 1.05469C9.2359 1.05469 11.6016 3.42035 11.6016 6.32812C11.6016 7.56577 11.1457 9.00415 10.2079 10.7254C9.10378 12.7522 7.52815 14.8081 6.32812 16.5364C5.12828 14.8083 3.55254 12.7523 2.44832 10.7254C1.51056 9.00415 1.05469 7.56577 1.05469 6.32812C1.05469 3.42035 3.42035 1.05469 6.32812 1.05469Z",
    fill: "#161717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 9.49219C8.07279 9.49219 9.49219 8.07279 9.49219 6.32812C9.49219 4.58346 8.07279 3.16406 6.32812 3.16406C4.58346 3.16406 3.16406 4.58346 3.16406 6.32812C3.16406 8.07279 4.58346 9.49219 6.32812 9.49219ZM6.32812 4.21875C7.49123 4.21875 8.4375 5.16502 8.4375 6.32812C8.4375 7.49123 7.49123 8.4375 6.32812 8.4375C5.16502 8.4375 4.21875 7.49123 4.21875 6.32812C4.21875 5.16502 5.16502 4.21875 6.32812 4.21875Z",
    fill: "#161717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaction);
export default __webpack_public_path__ + "static/media/Loaction.365e153d414fcc8d5bff38aa43c55a53.svg";
export { ForwardRef as ReactComponent };